import { createFileRoute } from "@tanstack/react-router"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import { useEffect } from "react"
import { Separator } from "@/components/ui/separator.tsx"
import { useTranslation } from "react-i18next"
import { getStoredLocale } from "@/lib/utils.ts"

export const Route = createFileRoute("/_protected/terms")({
  ssr: false,
  component: RouteComponent,
})

function RouteComponent() {
  const { setTitle } = usePageTitle()
  const { t } = useTranslation()
  const locale = getStoredLocale()

  useEffect(() => {
    setTitle(t("sidebar.terms"))
  }, [setTitle])
  return locale === "ar" ? (
    <div className="auto px-6 py-5">
      <div className="space-y-4 text-right leading-7">
        <p>
          مرحبا بكم في إيجاب! منصتك لترويج عروضك الصحفية إلى المحررين العالميين.
        </p>

        <p>
          تهدف شروط الخدمة هذه ("الشروط") في المقام الأول إلى تحديد العلاقة بينك
          كصحفي وبين إيجاب. وتشكل تلك الشروط اتفاقيتك معنا لاستخدام خدماتنا.
        </p>

        <p>
          وبناء على ذلك، إذا قبلت شروط الخدمة الخاصة بنا هذه، فإنك مدرك أنك
          توافق على الالتزام بهذه الشروط وبسياسة الخصوصية الخاصة بنا، والتي يمكن
          الوصول إليها من خلال هذا الرابط:
          <a
            href="https://docs.google.com/document/d/14AaXj4klUXjl8uYPEcl4xi8xA5HJpMJC/edit?usp=sharing&ouid=111297305786080699497&rtpof=true&sd=true"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary underline underline-offset-4"
          >
            إيجاب - سياسة الخصوصية
          </a>
        </p>

        <p>
          أنت تدرك جيداً أيضا أنه قد يتم تعديل كلتا الوثيقتين من وقت لآخر وفقا
          لتقدير إيجاب وحدها، حيث تدخل هذه التعديلات حيز التنفيذ اعتباراً من
          لحظة أن نرسل إليك بريد إلكتروني يخطرك بهذا التعديل.
        </p>

        <p>
          علاوة على ذلك، فإنك توافق على الامتثال لأي إرشادات أو قواعد إضافية
          منشورة بما في ذلك ما يتعلق باستخدام منصاتنا الإلكترونية وخدماتنا
          وخصائصنا.
        </p>

        <p>
          لذلك، إذا كنت لا توافق على ذلك، فلديك الحرية - للأسف - في التوقف عن
          استخدام خدماتنا.
        </p>

        <p>
          تنطبق شروط الخدمة على جميع مواقع الويب وتطبيقات الهاتف المحمول التابعة
          مباشرة لإيجاب، إن وجدت، وإلى الحد المسموح به. علاوة على ذلك، لا تمتد
          شروط الخدمة إلى أي مواقع ويب أو تطبيقات جوال أو منصات إلكترونية تابعة
          للغير.
        </p>

        <ol className="list-decimal space-y-6 pr-6 marker:font-bold">
          <li>
            <h3 className="mb-3 text-base font-bold">عن إيجاب</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                يتم تشغيل هذه المنصة من قبل شركة إيجاب للمحتوى الرقمي، وهي شركة
                ذات مسؤولية محدودة تأسست في جمهورية مصر العربية، مسجلة بالسجل
                التجاري برقم 146658.
              </li>

              <li>
                في سياق تلك الشروط، يتم استخدام مصطلح "إيجاب" للإشارة لكل من
                الشركة المذكورة تحت القسم 1.1 والمنصة الإلكترونية، كما قد يتم
                فهمه من السياق.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">خدماتنا</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                ولأغراض شروط الخدمة هذه:
                <ol className="mt-3 list-decimal space-y-3 pr-6">
                  <li>
                    يجب أن يشير "المحتوى" إلى أي حقوق الطبع والنشر، سواء كانت
                    مسجلة أم لا، أو خواطر، أو أفكار، أو تحليل، أو بيانات، أو
                    بحث، أو معلومات، أو صور، أو رسومات، أو أصوات، أو نصوص، أو أي
                    مواد مماثلة ذات صلة بالصحافة، أو مجالات أخرى مقبولة من قبل
                    إيجاب، ومقدمة من قبل الصحفي لخدمات إيجاب.
                  </li>

                  <li>
                    يشير مصطلح "مشترين المحتوى" إلى وسائل الإعلام التابعة لجهات
                    خارجية من الغير والناشرين والمجلات والبوابات الإلكترونية.
                  </li>

                  <li>
                    "أنت" أو "الصحفي" يجب أن تشير إلى الصحفيين المسجلين عبر موقع
                    إيجاب الإلكتروني.
                  </li>

                  <li>تشمل "الخدمات" الأقسام 2.2 إلى 2.5.</li>
                </ol>
              </li>

              <li>
                إيجاب منصة إلكترونية تقوم بما يلي:
                <ol className="mt-3 list-decimal space-y-3 pr-6">
                  <li>
                    تقييم محتوى الصحفي لتحديد ما إذا كانت إيجاب، في تقديرها
                    الشخصي والكامل، تعتقد أنها قادرة على ترويج هذا المحتوى إلى
                    مشترين المحتوى.
                  </li>

                  <li>
                    وبعد إجراء ذلك التقييم من قبل إيجاب، يتم وضع محتوى الصحفي في
                    شكل وصيغة مناسبين، بهدف تقديمه إلى مشترين المحتوى.
                  </li>

                  <li>
                    العمل على عرض وتقديم محتوى الصحفي إلى مشترين المحتوى، بهدف
                    بيعه لهم لأغراض النشر.
                  </li>

                  <li>
                    التفاوض على الرسوم المستحقة للمحتوى مع مشترين المحتوى.
                  </li>

                  <li>
                    الحصول على موافقة الصحفي على الرسوم المستحقة للمحتوى، قبل
                    المتابعة مع مشتري المحتوى.
                  </li>
                </ol>
              </li>

              <li>
                تقوم إيجاب بتحصيل المبلغ الكامل من مشتري المحتوى وتحويله إلى
                الصحفي، بعد خصم عمولتها كما هو محدد في القسم 5.1.
              </li>

              <li>
                قد تحتاج إيجاب، دون تغيير جوهر المحتوى، إلى ضبط المحتوى وتعديله
                ووضعه في صيغة مناسبة واحترافية لتقديم هذه الأعمال إلى مشترين
                المحتوى بأفضل طريقة ممكنة.
              </li>

              <li>
                من أجل تقديم خدماتنا، فإنك تقوم صراحة بتفويض إيجاب للتوقيع
                مادياً وإلكترونياً على اتفاقيات بيع وشراء المحتوى والموافقة
                عليها مع مشترين المحتوى، نيابة عنك.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">تنبيهات</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                أنت تدرك وتقر بأن خدماتنا يتم تقديمها على أساس الالتزام ببذل
                عناية، حيث تتعهد إيجاب ببذل جهود معقولة من أجل بيع المحتوى الخاص
                بك إلى مشترين المحتوى.
              </li>

              <li>
                وفقا لشروط الخدمة، فإنك تدرك أن إيجاب ليست سوى عامل تمكين، وأن
                خدماتنا لا تشمل شراء المحتوى الخاص بك لمصلحتنا الخاصة.
              </li>

              <li>
                عند تقديم الخدمات، لا تقدم إيجاب أي مشورة أو خدمات قانونية صريحة
                أو ضمنية من أي نوع.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">الانضمام</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                لاستخدام خدماتنا، يجب عليك الانضمام إلى برنامج إيجاب وتزويدنا
                بالتفاصيل والمعلومات المطلوبة، بما في ذلك:
                <ol className="mt-3 list-decimal space-y-2 pr-6">
                  <li>الاسم الأول والأخير.</li>
                  <li>مكان الإقامة.</li>
                  <li>رقم الهاتف المحمول المستخدم.</li>
                  <li>البريد الإلكتروني.</li>
                  <li>معلومات الدفع.</li>
                  <li>اللغات، سواء كانت منطوقة أو مكتوبة.</li>
                </ol>
              </li>

              <li>
                تظل بعض المعلومات اختيارية بالنسبة لك لتقديمها، مثل الاهتمامات
                والخبرات السابقة وأي معلومات أخرى معروضة على صفحة الانضمام.
              </li>

              <li>
                لديك الحق في إلغاء تسجيلك على منصتنا في أي وقت، شريطة ألا توجد
                أي خدمات حالية غير مكتملة.
              </li>

              <li>
                يحق لإيجاب إلغاء حسابك وفقا لتقديرها الخاص في حالة انتهاكك لأي
                من أحكام شروط الخدمة هذه أو أي قوانين ولوائح معمول بها.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">العمولة وطريقة الدفع</h3>

            <ol className="list-decimal space-y-4 pr-6">
              <li>
                <span className="font-semibold">العمولة</span>

                <ol className="mt-3 list-decimal space-y-3 pr-6">
                  <li>
                    بعد إبرام اتفاقية شراء المحتوى بين مشتري المحتوى والصحفي،
                    يجب أن تتلقى إيجاب المقابل المتفق عليه على حسابها المصرفي
                    الخاص. بعد ذلك، تقوم إيجاب بخصم خمسين بالمائة (50٪) من
                    المبلغ المتفق عليه كعمولة.
                  </li>

                  <li>
                    وتحسب العمولة على أساس إجمالي المقابل لاتفاقية الشراء
                    المذكورة أعلاه.
                  </li>

                  <li>
                    العمولة هي مبلغ صاف لا يشمل أي رسوم تحويل و/أو ضرائب حكومية
                    وخصومات ورسوم ومصاريف واستحقاقات.
                  </li>
                </ol>
              </li>

              <li>
                <span className="font-semibold">آلية النقل</span>

                <ol className="mt-3 list-decimal space-y-3 pr-6">
                  <li>
                    لا يجوز تحويل مستحقاتك إلا من خلال طرق غير نقدية. وفي حالة
                    الحاجة يمكن التواصل عبر:
                    <a
                      href="mailto:accounting@egab.co"
                      className="text-primary underline underline-offset-4"
                    >
                      accounting@egab.co
                    </a>
                  </li>

                  <li>
                    تقع المسؤولية الكاملة لتوفير آلية تحويل مضمونة وقابلة
                    للتطبيق على عاتقك.
                  </li>

                  <li>
                    عند تحويل مستحقاتك، تلتزم شركة إيجاب بتزويدك بإثبات التحويل.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">شرط الحصرية</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>أنت تدرك وتقر بأن خدماتنا تُقدم على أساس غير حصري.</li>

              <li>
                منذ تقديم المحتوى الخاص بك إلى إيجاب، فإن إيجاب تستفيد من حق
                حصري على المحتوى والتصرف فيه وفقاً لشروط الخدمة.
              </li>

              <li>
                في حالة انتهاك هذا الحق الحصري، يحق لإيجاب فرض عقوبات والمطالبة
                بالتعويض إلى أقصى حد متاح بموجب القانون المعمول به.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">حد المسؤولية</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                تلتزم إيجاب بالامتثال لجميع القوانين واللوائح المعمول بها فيما
                يتعلق بإجراء التحويلات وخدماتها.
              </li>

              <li>
                عند تقديم الخدمات، لا تتحمل إيجاب المسؤولية باستثناء في حالات
                الإهمال الجسيم وسوء السلوك المتعمد والإجراءات غير المشروعة.
              </li>

              <li>
                لا تتحمل إيجاب أي مسؤولية فيما يتعلق بسلوك وأفعال مشترين
                المحتوى.
              </li>

              <li>
                يقر الصحفي أن إيجاب لا تتحمل أي مسؤولية قانونية عن الخسائر غير
                المباشرة أو التبعية أو الاستثنائية.
              </li>

              <li>
                الصحفي ملزم بالدفاع عن إيجاب وتعويضها وتجنيبها من أي أضرار تنشأ
                عن انتهاك الصحفي لشروط الخدمة أو القوانين المعمول بها.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">التعهدات والضمانات</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                أنت تقر بأن لديك الأهلية القانونية الكاملة للموافقة على بنود
                شروط الخدمة هذه.
              </li>

              <li>
                يجب على الصحفي الالتزام بجميع المواعيد النهائية المتفق عليها
                والنتائج المستهدفة.
              </li>

              <li>
                يقر الصحفي بالمسؤولية الكاملة والملكية للمحتوى المقدم إلى إيجاب.
              </li>

              <li>
                يجب على الصحفي الامتثال لجميع القوانين واللوائح المحلية والدولية
                المعمول بها.
              </li>

              <li>
                يقر الصحفي بمصداقية ودقة وأصالة وملكية المحتوى المقدم لإيجاب.
              </li>

              <li>
                يقر الصحفي أن إيجاب لا تتحمل أي مسؤولية قانونية في حالة حدوث
                خسائر غير مباشرة أو تبعية.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">العلاقة بين الطرفين</h3>

            <p>
              يعتبر كل من إيجاب والصحفي متعاقداً مستقلاً. ولا ينظر إلى علاقتهما
              على أنها اتفاقية توظيف أو وكالة، أو أي شيء سوى اتفاقية تقديم
              خدمات.
            </p>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">شرط السرية</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                يجب أن تظل جميع المعلومات التي يتم تبادلها مع إيجاب سرية ولا يجب
                الكشف عنها للغير إلا لأغراض تنفيذ الالتزامات أو الوفاء بالتزام
                قانوني.
              </li>

              <li>
                لا يجوز تحميل إيجاب أي مسؤولية في حالة مشاركة أو الكشف عن محتوى
                ذي صلة لمشترين المحتوى.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">
              حقوق الملكية الفكرية لإيجاب
            </h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                جميع المحتويات المضمنة في الموقع الإلكتروني وتطبيق الهاتف
                المحمول من الملكية الحصرية وحقوق الطبع والنشر لشركة إيجاب أو
                المرخصين التابعين لها.
              </li>

              <li>
                جميع العلامات التجارية وحقوق النشر الأخرى غير المملوكة لشركة
                إيجاب هي ملك لأصحابها المعنيين.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">التنازل عن الحقوق</h3>

            <p>
              لا يشكل فشل إيجاب في ممارسة أي حقوق أو سلطة أو امتياز بموجب شروط
              الخدمة هذه تنازلاً عن أي ممارسة لاحقة أو إضافية لذلك الحق.
            </p>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">الحوالة</h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                لا يجوز للصحفي أن يحيل أو يتنازل أو ينقل أي من الحقوق أو
                الالتزامات الناشئة بموجب شروط الخدمة.
              </li>

              <li>
                لإيجاب الحق المطلق في حوالة أو نقل أي من حقوقها والتزاماتها.
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">الإخطار</h3>

            <p>
              يجب أن تكون جميع الإشعارات والمراسلات بينك وبين إيجاب عبر المنصة
              أو عبر البريد الإلكتروني، ويكون لها تأثير قانوني كامل.
            </p>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">شرط القوة القاهرة</h3>

            <p>
              لا يجوز تحميل إيجاب و/أو الصحفي المسؤولية عن أي إخفاق أو تأخير في
              أداء الالتزامات في حالة وجود قوة قاهرة خارجة عن الإرادة.
            </p>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">
              القانون المعمول به وآلية تسوية المنازعات
            </h3>

            <ol className="list-decimal space-y-3 pr-6">
              <li>
                تخضع شروط الخدمة هذه لقوانين جمهورية مصر العربية ويتم تفسيرها
                وفقاً لها.
              </li>

              <li>
                في حالة وجود أي مطالبات أو شكاوى، يمكنك التواصل عبر:
                <a
                  href="mailto:clientsupport@egab.co"
                  className="text-primary underline underline-offset-4"
                >
                  clientsupport@egab.co
                </a>
              </li>

              <li>
                يتم تسوية أي نزاع أو خلاف عن طريق التحكيم وفقاً لقواعد مركز
                القاهرة الإقليمي للتحكيم التجاري الدولي (CRCICA).
              </li>
            </ol>
          </li>

          <li>
            <h3 className="mb-3 text-base font-bold">اللغة</h3>

            <p>
              اللغة الأصلية لبنود الخدمة هي اللغة الإنجليزية. أي ترجمة مقدمة
              لراحتك فقط، وفي حالة وجود أي تناقض تكون الأولوية للنسخة
              الإنجليزية.
            </p>
          </li>
        </ol>
      </div>
    </div>
  ) : (
    <div className="mx-auto w-full leading-relaxed">
      <h1 className="mb-6 text-2xl font-bold">Terms of Service</h1>

      <p className="mb-4">
        Welcome to Egab! Your platform to have your journalism pitches reach
        global editors.
      </p>

      <p className="mb-4">
        These Terms of Service (“ToS”) primarily aim to draw the relationship
        between Egab and you, as a journalist. It constitutes your agreement
        with us for the usage of our services.
      </p>

      <p className="mb-4">
        Accordingly, if you accept our ToS, you understand that you agree to be
        bound by it and also by our Privacy Policy, accessible through this
        link:{" "}
        <a
          href="https://docs.google.com/document/d/14AaXj4klUXjl8uYPEcl4xi8xA5HJpMJC/edit?usp=sharing&ouid=111297305786080699497&rtpof=true&sd=true"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline"
        >
          EGAB – Privacy Policy
        </a>
        . You are also well aware that both documents may be amended from time
        to time in accordance with Egab's sole discretion, as these amendments
        shall come into effect from the moment of sending you a notification of
        their occurrence via email or the platform.
      </p>

      <p className="mb-4">
        Further, you agree to comply with any additional posted guidelines or
        rules including regarding the usage of our platforms, services, and
        features.
      </p>

      <p className="mb-4">
        Therefore, if you do not agree on such, you have the freedom to –
        unfortunately – quit using our services.
      </p>

      <p className="mb-8">
        The ToS are applicable over all of Egab's directly affiliated websites
        and mobile applications, if existed, and to the extent permissible.
        Further, the ToS do not extend to any third-party websites, mobile
        applications, and platforms.
      </p>

      <Separator className="mb-6" />

      <h2 className="mb-2 text-lg font-semibold">1. About Egab</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          This platform is operated by Egab for Digital Content, a limited
          liability company incorporated in the Arab Republic of Egypt, with
          commercial register No. 146658.
        </li>
        <li>
          Reference to “Egab” under the ToS shall be employed for both the
          company mentioned under section 1.1 and the online platform, as may be
          understood from the context.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">2. Our Services</h2>
      <ol className="mb-8 list-decimal space-y-3 pl-5">
        <li>
          For the purposes of this ToS:
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-5">
            <li>
              “Content” shall refer to any articulated copyrights, whether
              registered or not, thoughts, ideas, analysis, data, research,
              information, images, graphics, sounds, texts, any similar material
              relevant to journalism, or other domains accepted by Egab,
              submitted by the journalist for Egab's services.
            </li>
            <li>
              “Content Buyers” means third-party media outlets, publishers,
              journals, and portals.
            </li>
            <li>
              “You” or “Journalist” shall refer to Egab's journalists registered
              over its website.
            </li>
            <li>“Services” shall be inclusive of sections 2.2 to 2.5.</li>
          </ol>
        </li>
        <li>
          Egab is a platform that undertakes the following:
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-5">
            <li>
              Evaluating the Content of the Journalist to determine if Egab, in
              its sole and entire judgment, believes it is able to pitch such
              Content to Content Buyers;
            </li>
            <li>
              Following Egab's evaluation, placing the Content of the Journalist
              in an appropriate format and standard, with the aim of presenting
              it to Content Buyers;
            </li>
            <li>
              Working to show and present the Content of the Journalist to the
              Content Buyer, with the aim of selling them for the purposes of
              publication;
            </li>
            <li>
              Negotiating the fees payable for the Content with the Content
              Buyer;
            </li>
            <li>
              Gaining approval for the fees payable for the Content from the
              Journalist, before proceeding with the Content Buyer.
            </li>
          </ol>
        </li>
        <li>
          Egab shall collect the full payment from the Content Buyer and
          transfer it to the journalist, after deducting its Commission (as
          defined under section 5.1).
        </li>
        <li>
          Egab, without changing the essence of the Content, may need to adjust,
          edit and place the Content in a suitable and professional format to
          present these work to the Content Buyers in the best possible manner.
        </li>
        <li>
          In order to render our Services, you explicitly delegate Egab to
          physically and electronically sign on, and agree to, Content sale and
          purchase agreements vis-à-vis Content Buyers, on Your behalf.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">3. Disclaimers</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          You understand and acknowledge that our Services are offered on an
          obligation of means basis, as Egab will deploy its reasonable efforts
          in order to sell Your Content to Content Buyers. For the avoidance of
          doubt, Egab does not guarantee that any of the Content Buyers that
          reviews the Content owned by the Journalist will accept or agree to
          purchase or publish this Content, with no liability whatsoever
          incurred by Egab in this respect.
        </li>
        <li>
          Pursuant to the ToS, you understand that Egab is only an enabler, and
          that our Services are exclusive of buying your Content for our own
          benefit; as Egab does not hold any proprietary rights in anytime over
          the Content. Thus, and without prejudice to sub-section 2.5 and 6.2,
          the Content remains the ownership of the Journalist until a final
          exclusive sale and purchase agreement is concluded with the Content
          Buyer, upon which the Journalist transfers all of its proprietary
          rights over the Content to the concerned Content Buyer, without an
          option to revoke the Content for any reason.
        </li>
        <li>
          In rendering the Services, Egab does not offer any explicit or
          implicit legal advice or services of any kind.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">4. Onboarding</h2>
      <ol className="mb-8 list-decimal space-y-3 pl-5">
        <li>
          To use our Services, you must onboard over Egab and provide to us the
          required information details to ensure the due performance of our
          Services, including, but not limited to:
          <ol className="mt-2 list-[lower-alpha] space-y-1 pl-5">
            <li>First and last name;</li>
            <li>Place of residence;</li>
            <li>Active cellphone number;</li>
            <li>E-mail;</li>
            <li>Payment information;</li>
            <li>Languages, whether spoken or written.</li>
          </ol>
        </li>
        <li>
          Some information remain optional for you to provide, such as
          interests, previous experience, and any other information displayed
          over the onboarding page that does not have an asterisk (*) beside
          them. Please note that providing this information, even if optional,
          would increase your chances in having your Content sold to Content
          Buyers.
        </li>
        <li>
          You have the right to cancel your registration on our platform at any
          time, provided that; there are no present and uncompleted Services;
          otherwise, your account shall be upheld until settling all reciprocal
          financial and non-financial obligations and entitlements.
        </li>
        <li>
          Egab shall have the right to cancel your account at its sole
          discretion in case of your violation to any provisions of the ToS, or
          any applicable laws and regulations. The regulation of your
          entitlements post-cancellation shall be in accordance with our
          discretion, in the light of the concerned violation and the caused
          damage.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">
        5. Commission &amp; Payment Method
      </h2>
      <ol className="mb-8 list-decimal space-y-3 pl-5">
        <li>
          Commission:
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-5">
            <li>
              Post the conclusion of the Content purchase agreement between the
              Content Buyer and the journalist, Egab shall receive the
              agreed-upon consideration through its own bank account.
              Afterwards, Egab shall deduct fifty percent (50%) of the
              agreed-upon payment as a commission (“Commission”).
            </li>
            <li>
              The Commission is calculated on the gross total consideration of
              the aforementioned purchase agreement.
            </li>
            <li>
              The Commission is a net amount that is exclusive of any transfer
              fees and/or governmental taxes, deductions, fees, charges, and
              entitlements, imposed at any time prior to making the final
              transfer to the journalist.
            </li>
          </ol>
        </li>
        <li>
          Transfer Mechanism:
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-5">
            <li>
              Your entitlements may only be transferred through cashless
              methods. The types of transfer methods available over Egab may
              differ from time to time. However, and without prejudice to any
              applicable laws and regulations, in case this arrangement is not
              suitable per your case, you are invited to contact us to reach an
              alternative and feasible solution through this e-mail:{" "}
              <a
                href="mailto:accounting@egab.co"
                className="text-primary underline"
              >
                accounting@egab.co
              </a>
            </li>
            <li>
              The responsibility of providing a secured and feasible transfer
              mechanism totally lies upon you. Thus, Egab would never be liable
              for the failure or delay of the transfer mechanism you chose in
              transferring your entitlements. Any disputes in this regard should
              be raised against your payment service provider.
            </li>
            <li>
              Upon transferring your entitlements, Egab is obliged to provide to
              you a proof of transfer.
            </li>
          </ol>
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">6. Exclusivity</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          You understand and acknowledge that our Services are offered on a
          non-exclusive basis; as our Services are accessible for any
          journalists or editors without any limitation.
        </li>
        <li>
          Without prejudice to section 8, you understand and acknowledge that by
          submitting your Content to Egab, Egab benefits of an exclusive right
          over the Content and its disposal, and that you may not sell, dispose,
          present, disclose, display, publish, submit, circulate, or pitch the
          Content to any third-party in any way, directly or indirectly, for a
          financial consideration or not, as long as Egab did not waive such a
          right explicitly in writing at its sole discretion or did not
          explicitly reject to receive the Content in writing. In case of
          violating this exclusivity right from your side, Egab shall have the
          right to impose penalties, and to claim compensation to the maximum
          extent available under the applicable law.
        </li>
        <li>
          In case of violating this exclusivity right from your side, Egab shall
          have the right to impose penalties, and to claim compensation to the
          maximum extent available under the applicable law.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">7. Limitation of Liability</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          Without prejudice to any provision on the limitation of liability
          under the ToS, Egab commits to comply with all applicable laws and
          regulations in respect of making transfers and its Services; further,
          Egab shall not hold any liability for the non-performance of the
          transfer or Services pursuant to applicable rules and orders.
        </li>
        <li>
          In rendering the Services, Egab may not be held liable except for
          gross negligence, willful misconduct, and illegitimate actions, all to
          the minimum extent applicable under Egyptian law.
        </li>
        <li>
          Egab does not hold any liability in respect of the conduct and actions
          of the Content Buyers.
        </li>
        <li>
          The Journalist acknowledges that Egab does not hold any legal
          liability in the event of any loss in profit or business, damage to
          the commercial reputation, or similar damage or losses, or in the
          event that data or information is destroyed, lost or in the event of
          gross economic loss, exceptional, indirect or consequential loss or
          the event that any costs, compensation, fees or expenses incurred,
          regardless of how they fall within the framework of this Agreement.
        </li>
        <li>
          The Journalist is obliged to defend, indemnify, and spare Egab from
          any damages of any type arising from any claims, cases, procedures,
          losses, expenses or costs (including in general but not limited to
          judicial costs and legal fees), which may arise due to the
          Journalist's violation of any terms of the ToS or any laws or local
          regulations or codes of ethics.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">
        8. Representations &amp; Warranties
      </h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          You represent that you have full legal capacity to agree on the ToS,
          in accordance with your local laws and regulations.
        </li>
        <li>
          The Journalist shall comply with all agreed deadlines and deliverables
          set forth by Egab via the platform or communicated via e-mail. In case
          of failure to deliver upon the agreed deadlines without written
          approval from Egab beforehand, the Journalist may be charged a penalty
          fee equivalent to the article's fees agreed upon between Egab and the
          Content Buyer as liquidated damages.
        </li>
        <li>
          The Journalist acknowledges full liability and ownership for the
          Content submitted to Egab and further acknowledges that Egab is not
          liable for any Content that may violate the law or the copyrights of a
          third-party.
        </li>
        <li>
          The Journalist must follow all applicable local and international laws
          and regulations regarding Journalist's activities and services.
          Further the Journalist must adhere and commit to all recognized
          professional norms and principles.
        </li>
        <li>
          The Journalist acknowledges the credibility, accuracy, originality,
          and ownership of the Content provided to Egab, and in the event that
          it was proven to Egab that the aforementioned Content is plagiarized,
          not factual, has been modified from previous content, then Egab shall
          have the right to immediately terminate its dealings with the
          concerned Journalist and cancel its account, without need for any
          notices, or judicial procedures or procuring a judgment or an arbitral
          award. Further, Egab shall inform the Content Buyers it deals with of
          the violations which could impact the reputation of Egab. The
          Journalist acknowledges that plagiarism affects Egab's reputation and
          on that basis Egab could seek financial compensation from the
          Journalist in the case of plagiarism or fake Content offered to Egab.
        </li>
        <li>
          The Journalist acknowledges that Egab does not hold any legal
          liability in the event of any loss in profit or business, damage to
          the commercial reputation, or similar damage or losses, or in the
          event that data or information is destroyed, lost or in the event of
          gross economic loss, exceptional, indirect or consequential loss or
          the event that any costs, compensation, fees or expenses incurred,
          regardless of how they fall within the framework of this ToS.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">
        9. Relationship between the Parties
      </h2>
      <p className="mb-8">
        Each of Egab and the journalist is an independent contractor; and their
        relationship may not be perceived as an employment or agency agreement,
        or anything but a service agreement.
      </p>

      <h2 className="mb-2 text-lg font-semibold">10. Confidentiality</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          All information exchanged with Egab shall remain confidential and
          shall not be disclosed to a third-party except where the disclosure is
          for the purposes of performing the obligations underlying the ToS or
          to fulfill a legal obligation.
        </li>
        <li>
          Consequently, and without prejudice to sub-section 6.2, You shall not
          hold Egab liable for sharing and/or disclosing any relevant Content in
          the present or in the future to Content Buyers.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">
        11. Intellectual Property Rights of Egab
      </h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          All content included on the website and mobile application, including
          but not limited to text, graphics, Egab's logos, button icons, images,
          colors, audio clips, digital downloads, data compilations, and
          software, is the exclusive property and copyright work of Egab or its
          licensors, and is protected by copyright, trademarks, patents or other
          intellectual property rights' laws and regulations. The compilation of
          the content on the website and mobile application is the exclusive
          property and copyright of Egab and is protected by copyright,
          trademarks, patents, or other intellectual property rights and laws.
        </li>
        <li>
          All other trademarks and/or copyrights not owned by Egab that appear
          on the website and/or mobile application are the property of their
          respective owners, who may or may not be affiliated with, connected
          to, or sponsored by, Egab.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">12. Waiver of Rights</h2>
      <p className="mb-8">
        The failure of Egab to exercise any rights, power or privilege under the
        ToS shall not constitute by itself a waiver of any subsequent or further
        exercise of that or any other right, power of privilege or the exercise.
      </p>

      <h2 className="mb-2 text-lg font-semibold">13. Assignment</h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          You may not assign or transfer any of their rights or obligations
          under the ToS, or as provided to their respective accounts.
        </li>
        <li>
          Egab has an absolute right to transfer any of its rights and
          obligations.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">14. Notices</h2>
      <p className="mb-8">
        All notices and correspondences between you and Egab shall be via the
        platform or via e-mail, and shall maintain a full legal effect.
      </p>

      <h2 className="mb-2 text-lg font-semibold">15. Force Majeure</h2>
      <p className="mb-8">
        In no event shall Egab and/or the journalist be held liable for any
        failure or delay in the performance of their obligations hereunder in
        the event where the latter faced directly or indirectly an
        unforeseeable, irresistible force that was beyond its control. Provided
        that, the defaulting party immediately notifies the other party in
        writing of the existence of an event of force majeure.
      </p>

      <h2 className="mb-2 text-lg font-semibold">
        16. Applicable Law &amp; Dispute Resolution Mechanism
      </h2>
      <ol className="mb-8 list-decimal space-y-2 pl-5">
        <li>
          The ToS is governed by, and construed in accordance with, the laws of
          the Arab Republic of Egypt.
        </li>
        <li>
          In case you have any claims or complaints regarding any of our
          services, you are obliged to first communicate with our support team
          through:{" "}
          <a
            href="mailto:clientsupport@egab.co"
            className="text-primary underline"
          >
            clientsupport@egab.co
          </a>
          . In case your complaint has not been settled in a manner that is
          satisfactory to you within thirty (30) days, you may resort to
          arbitration in accordance with the following section.
        </li>
        <li>
          Any dispute, controversy or claim arising out of or relating to this
          contract, its interpretation, execution, the termination or invalidity
          thereof, shall be settled by arbitration in accordance with the Rules
          of Arbitration of the Cairo Regional Centre for International
          Commercial Arbitration (CRCICA). The seat of arbitration shall be in
          Egypt; the tribunal shall be composed of a sole arbitrator; and the
          proceedings shall be in Arabic.
        </li>
      </ol>

      <h2 className="mb-2 text-lg font-semibold">17. Language</h2>
      <p className="mb-4 pb-6">
        The original language of the ToS is English. Where we have provided a
        translation of the English version of the ToS, you agree that the
        translation is provided for your convenience only and that the English
        language version of the ToS will govern your relationship with us. If
        there is any contradiction between what the English language version of
        the ToS say and what a translation says, then the English language
        version will take precedence.
      </p>
    </div>
  )
}
